import { intl } from "@tci18n/vue2"; // D:\workspace\abroad-hrms-web\src\libs\export.js
/**
 * 通用Excel导出工具类
 * 提供通用的Excel导出功能，适用于任何表格数据
 */

import ExcelJS from 'exceljs';

const ExportUtil = {
  /**
   * 导出Excel文件（xlsx格式）
   * @param {Array} data - 表格数据，数组格式，每个元素为一行数据对象
   * @param {Array} columns - 列配置，格式: [{key: '字段名', title: '显示标题'}]
   * @param {String} fileName - 文件名（不含扩展名），默认'导出数据'
   * @returns {Boolean} - 是否导出成功
   */
  async exportExcel(data, columns, fileName = intl.$t("导出数据")) {
    try {
      // 验证输入参数
      if (!Array.isArray(data) || !Array.isArray(columns)) {
        throw new Error(intl.$t("数据或列配置格式不正确"));
      }

      // 使用ExcelJS创建工作簿
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');

      // 添加表头
      const headerRow = worksheet.addRow(columns.map((col) => col.title));
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      });

      // 添加数据行
      data.forEach((row) => {
        const rowData = columns.map((col) => {
          const value = row[col.key];
          // 处理null和undefined
          return value != null ? value : '';
        });
        worksheet.addRow(rowData);
      });

      // 设置列宽（可配置或使用默认值）
      worksheet.columns = columns.map((col) => ({
        key: col.key,
        width: col.width || 15
      }));

      // 生成arrayBuffer
      const buffer = await workbook.xlsx.writeBuffer();

      // 创建下载链接
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      return true;
    } catch (error) {
      console.error('导出Excel失败:', error);
      return false;
    }
  }
};

export default ExportUtil;